import { render, staticRenderFns } from "./authForm.vue?vue&type=template&id=665e102c&scoped=true"
import script from "./authForm.vue?vue&type=script&lang=js"
export * from "./authForm.vue?vue&type=script&lang=js"
import style0 from "./authForm.vue?vue&type=style&index=0&id=665e102c&prod&lang=scss&scoped=true"
import style1 from "./authForm.vue?vue&type=style&index=1&id=665e102c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e102c",
  null
  
)

export default component.exports